import { useQuery } from "@tanstack/react-query";
import { fetchSavedFilters, SavedFiltersV2Response } from "PFCore/services/filters";
import { QueryOptions } from "PFTypes/request_options";
import { PageTarget } from "PFTypes/saved_filters";

import { savedFiltersKeys } from "./query_keys";

export const useSavedFiltersV2 = (target: PageTarget, options: QueryOptions<SavedFiltersV2Response> = {}) =>
  useQuery<SavedFiltersV2Response>({
    queryFn: () => fetchSavedFilters(target),
    queryKey: savedFiltersKeys.target(target),
    ...options
  });
